import { Seo, breadcrumbJsonLd, SERVICE_JSONLD } from "@/lib/Seo";
import { PageHeader } from "@/components/PageHeader";
import { HowItWorks } from "@/sections/HowItWorks";
import { SmokeBanner } from "@/sections/SmokeBanner";
import { SystemSchema } from "@/sections/SystemSchema";
import { DemoSection } from "@/sections/DemoSection";
import { Reliability } from "@/sections/Reliability";
import { Link } from "react-router-dom";
import { btnPrimary } from "@/lib/ui";
import { ArrowRight } from "lucide-react";

const BREADCRUMB = [
  { name: "Home", path: "/" },
  { name: "Hoe het werkt", path: "/hoe-het-werkt" },
];

export default function HowItWorksPage() {
  return (
    <>
      <Seo
        title="Hoe werkt thermische branddetectie met camera's?"
        description="Ontdek hoe Hikvision thermische camera's warmtepatronen registreren, temperatuurzones bewaken en een vooralarm of alarm kunnen activeren binnen recyclingbedrijven."
        jsonLd={[breadcrumbJsonLd(BREADCRUMB), SERVICE_JSONLD]}
      />
      <PageHeader
        overline="Uitleg"
        title="Hoe werkt thermische branddetectie?"
        intro="Van infraroodmeting tot alarmopvolging: zo bewaakt een thermisch camerasysteem de risicogebieden op uw terrein."
        breadcrumb={BREADCRUMB}
      />
      <HowItWorks />
      <SmokeBanner />
      <DemoSection />
      <SystemSchema />
      <Reliability />
      <section className="pb-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
          <Link to="/offerte" className={btnPrimary} data-testid="how-page-cta">
            Laat uw risicogebieden in kaart brengen <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </>
  );
}
